import React, {useEffect} from 'react';
import {loadTimelineData} from 'anima-timeline';
import './BlogPage.css';
import Navbar from '../../Mobile/NavBar';
import Footer from '../../Mobile/Footer';
import BlogCard from '../../Common/BlogCards';


function App() {
  return <X08BlogsPageMOBILE {...x08BlogsPageMOBILEData} />;
}

export default App;

function X08BlogsPageMOBILE(props) {
  const {
    frame145,
    blogs,
    overlapGroup1,
    text237,
    frame1626Props,
    button22Props,
    group212Props,
    frame16372Props,
    frame163722Props,
    frame163723Props,
  } = props;

  return (
    <div  className="bpm-container-center-horizontal">
      <div  className="bpm-x08-blogs-page-mobile screen">
        <div  className="bpm-overlap-group">
          <div  className="bpm-frame-1663">
            <Navbar />
            {/* <img  className="bpm-frame-145" src={frame145} /> */}
            <h1  className="bpm-title bpm-valign-text-middle bpm-typographyheadlineh4-extrabold-24">{blogs}</h1>
            <div  className="bpm-overlap-group1" style={{ backgroundImage: `url(${overlapGroup1})` }}>
              <Frame1626
                latestVideos={frame1626Props.latestVideos}
                text339={frame1626Props.text339}
                address={frame1626Props.address}
              />
            </div>
            <p  className="bpm-text-3 bpm-typography-body-smalltext-14-regular">{text237}</p>
            <BlogCard />
            <Button22>{button22Props.children}</Button22>
            <Footer />
            {/* <Group212
              group86={group212Props.group86}
              group87={group212Props.group87}
              group32Props={group212Props.group32Props}
              frame5Props={group212Props.frame5Props}
            /> */}
          </div>
          
          {/* <Frame16372
            frame1598Props={frame16372Props.frame1598Props}
            frame15982Props={frame16372Props.frame15982Props}
          />
          <Frame16372
            className={frame163722Props.className}
            frame1598Props={frame163722Props.frame1598Props}
            frame15982Props={frame163722Props.frame15982Props}
          />
          <Frame16372
            className={frame163723Props.className}
            frame1598Props={frame163723Props.frame1598Props}
            frame15982Props={frame163723Props.frame15982Props}
          /> */}
        </div>
      </div>
    </div>
  );
}


function Frame1626(props) {
  const { latestVideos, text339, address } = props;

  return (
    <div  className="bpm-frame-1626">
      <div  className="bpm-address bpm-valign-text-middle bpm-typographybodytiny-10-regular">{latestVideos}</div>
      <p  className="bpm-text-4 bpm-valign-text-middle bpm-overpass-bold-white-16px">{text339}</p>
      <p  className="bpm-text-5 bpm-valign-text-middle bpm-typographybodytiny-10-regular">{address}</p>
    </div>
  );
}


function Button22(props) {
  const { children } = props;

  useEffect(() => {
    loadTimelineData(x27323835TimelineData);
  }, []);

  return (
    <div  className="bpm-x27323835 bpm-component bpm-component-wrapper not-ready">
      <div  className="bpm-master-button-yNBhMu">
        <div  className="bpm-button-i2732383551-x47ShW bpm-valign-text-middle">{children}</div>
      </div>
    </div>
  );
}

const x27323835TimelineData = [
  {
    initial_state_name: "Property-1=Tertiary",
    root_element: ".x27323835",
    states_flow: {
      "Property-1=Primary": {
        listeners: [],
        overrides: {},
      },
      "Property-1=Secondary": {
        listeners: [],
        overrides: {},
      },
      "Property-1=Tertiary": {
        listeners: [],
        overrides: {},
      },
    },
  },
];


function Group212(props) {
  const { group86, group87, group32Props, frame5Props } = props;

  return (
    <div  className="bpm-group-212">
      <div  className="bpm-flex-row">
        <img  className="bpm-group-86" src={group86} />
        <img  className="bpm-group-87" src={group87} />
      </div>
      <Group325
        place={group32Props.place}
        mapPin1={group32Props.mapPin1}
        phone={group32Props.phone}
        mail={group32Props.mail}
        text200={group32Props.text200}
        text199={group32Props.text199}
        contactWebuildCom={group32Props.contactWebuildCom}
      />
      <Frame5
        quickLinks={frame5Props.quickLinks}
        frame140Props={frame5Props.frame140Props}
        frame1402Props={frame5Props.frame1402Props}
        frame1403Props={frame5Props.frame1403Props}
      />
    </div>
  );
}


function Group325(props) {
  const { place, mapPin1, phone, mail, text200, text199, contactWebuildCom } = props;

  return (
    <div  className="bpm-group-32">
      <div  className="bpm-place bpm-valign-text-middle bpm-typographyheadlineh5-extrabold-20">{place}</div>
      <div  className="bpm-flex-row-1">
        <div  className="bpm-flex-col">
          <img  className="bpm-map-pin-1" src={mapPin1} />
          <img  className="bpm-phone" src={phone} />
          <img  className="bpm-mail" src={mail} />
        </div>
        <div  className="bpm-flex-col-1">
          <p  className="bpm-text-2 bpm-typography-body-smalltext-14-regular">{text200}</p>
          <div  className="bpm-flex-col-item bpm-valign-text-middle bpm-typography-body-smalltext-14-regular">{text199}</div>
          <div  className="bpm-flex-col-item bpm-valign-text-middle bpm-typography-body-smalltext-14-regular">
            {contactWebuildCom}
          </div>
        </div>
      </div>
    </div>
  );
}


function Frame5(props) {
  const { quickLinks, frame140Props, frame1402Props, frame1403Props } = props;

  return (
    <div  className="bpm-frame-5">
      <div  className="bpm-quick-links bpm-valign-text-middle bpm-typographyheadlineh5-extrabold-20">{quickLinks}</div>
      <div  className="bpm-frame-4">
        <Frame140 aboutUs={frame140Props.aboutUs} projects={frame140Props.projects} />
        <Frame140
          aboutUs={frame1402Props.aboutUs}
          projects={frame1402Props.projects}
          className={frame1402Props.className}
        />
        <Frame140
          aboutUs={frame1403Props.aboutUs}
          projects={frame1403Props.projects}
          className={frame1403Props.className}
        />
      </div>
    </div>
  );
}


function Frame140(props) {
  const { aboutUs, projects, className } = props;

  return (
    <div className={`bpm-frame-140 ${className || ""}`}>
      <div  className="bpm-about-us bpm-valign-text-middle bpm-typographybody16-regular">{aboutUs}</div>
      <div  className="bpm-projects bpm-valign-text-middle bpm-typographybody16-regular">{projects}</div>
    </div>
  );
}


function Frame16372(props) {
  const { className, frame1598Props, frame15982Props } = props;

  return (
    <div className={`bpm-frame-1637 ${className || ""}`}>
      <Frame1598
        blogThumbnail={frame1598Props.blogThumbnail}
        address={frame1598Props.address}
        text223={frame1598Props.text223}
        text224={frame1598Props.text224}
        frame1587Props={frame1598Props.frame1587Props}
      />
      <Frame1598
        blogThumbnail={frame15982Props.blogThumbnail}
        address={frame15982Props.address}
        text223={frame15982Props.text223}
        text224={frame15982Props.text224}
        className={frame15982Props.className}
        frame1587Props={frame15982Props.frame1587Props}
      />
    </div>
  );
}


function Frame1598(props) {
  const { blogThumbnail, address, text223, text224, className, frame1587Props } = props;

  return (
    <div className={`bpm-frame-1598-2 ${className || ""}`}>
      <img  className="bpm-blog-thumbnail" src={blogThumbnail} />
      <div  className="bpm-address-1 bpm-valign-text-middle bpm-overpass-semi-bold-scarpa-flow-16px">{address}</div>
      <div  className="bpm-text bpm-valign-text-middle bpm-typographyheadlineh5-extrabold-20">{text223}</div>
      <p  className="bpm-text-1 bpm-typography-body-smalltext-14-regular">{text224}</p>
      <Frame1587 text55={frame1587Props.text55} arrowsArrowRight={frame1587Props.arrowsArrowRight} />
    </div>
  );
}


function Frame1587(props) {
  const { text55, arrowsArrowRight } = props;

  return (
    <div  className="bpm-frame-1587">
      <div  className="bpm-read-more bpm-valign-text-middle bpm-typographybodycaption-14-semi-bold">{text55}</div>
      <img  className="bpm-arrowsarrow-right" src={arrowsArrowRight} />
    </div>
  );
}

const frame1626Data = {
    latestVideos: "05 June 2021",
    text339: "Lorem Ipsum passages of Lorem Ip...",
    address: "Lorem ipsum dolor sit amet, consectetur leo,…",
};

const button22Data = {
    children: "VIEW MORE",
};

const group325Data = {
    place: "Contact",
    mapPin1: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/releases/60eebc1043f87cba4b3aaef8/img/map-pin--1--2@2x.svg",
    phone: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-212@2x.svg",
    mail: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/releases/60eeef698718caded3164f97/img/mail-14@2x.svg",
    text200: "Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint.",
    text199: "+91 8976535221, +91 8755645342",
    contactWebuildCom: "contact@webuild.com",
};

const frame140Data = {
    aboutUs: "About Us",
    projects: "Projects",
};

const frame1402Data = {
    aboutUs: "Gallery",
    projects: "Knowledge Transfer",
    className: "bpm-frame-14",
};

const frame1403Data = {
    aboutUs: "Blogs",
    projects: "FAQ’s",
    className: "bpm-frame-14",
};

const frame5Data = {
    quickLinks: "Quick Links",
    frame140Props: frame140Data,
    frame1402Props: frame1402Data,
    frame1403Props: frame1403Data,
};

const group212Data = {
    group86: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/releases/60eeef698718caded3164f97/img/group-86-16@2x.svg",
    group87: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/releases/60eeef698718caded3164f97/img/group-87-8@2x.svg",
    group32Props: group325Data,
    frame5Props: frame5Data,
};

const frame1587Data = {
    text55: "Read More",
    arrowsArrowRight: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/releases/60eeef698718caded3164f97/img/arrows-arrow-right@2x.svg",
};

const frame1598Data = {
    blogThumbnail: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/releases/60eeef698718caded3164f97/img/blog-thumbnail-6@2x.svg",
    address: "5 June 2021",
    text223: "Lorem Ipsum passages of Lorem Ipsum available",
    text224: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer quis sapien ac massa dapibus lacinia. Nunc et cursus quam. Cras pharetra condimentum leo,…",
    frame1587Props: frame1587Data,
};

const frame15872Data = {
    text55: "Read More",
    arrowsArrowRight: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/releases/60eeef698718caded3164f97/img/arrows-arrow-right@2x.svg",
};

const frame15982Data = {
    blogThumbnail: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/releases/60eeef698718caded3164f97/img/blog-thumbnail-7@2x.svg",
    address: "5 June 2021",
    text223: "Lorem Ipsum passages of Lorem Ipsum available",
    text224: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer quis sapien ac massa dapibus lacinia. Nunc et cursus quam. Cras pharetra condimentum leo,…",
    className: "bpm-frame-1598-1",
    frame1587Props: frame15872Data,
};

const frame16372Data = {
    frame1598Props: frame1598Data,
    frame15982Props: frame15982Data,
};

const frame15873Data = {
    text55: "Read More",
    arrowsArrowRight: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/releases/60eeef698718caded3164f97/img/arrows-arrow-right@2x.svg",
};

const frame15983Data = {
    blogThumbnail: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/releases/60eeef698718caded3164f97/img/blog-thumbnail-8@2x.svg",
    address: "5 June 2021",
    text223: "Lorem Ipsum passages of Lorem Ipsum available",
    text224: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer quis sapien ac massa dapibus lacinia. Nunc et cursus quam. Cras pharetra condimentum leo,…",
    frame1587Props: frame15873Data,
};

const frame15874Data = {
    text55: "Read More",
    arrowsArrowRight: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/releases/60eeef698718caded3164f97/img/arrows-arrow-right@2x.svg",
};

const frame15984Data = {
    blogThumbnail: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/releases/60eeef698718caded3164f97/img/blog-thumbnail-9@2x.svg",
    address: "5 June 2021",
    text223: "Lorem Ipsum passages of Lorem Ipsum available",
    text224: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer quis sapien ac massa dapibus lacinia. Nunc et cursus quam. Cras pharetra condimentum leo,…",
    className: "bpm-frame-1598-1",
    frame1587Props: frame15874Data,
};

const frame163722Data = {
    className: "bpm-frame-1638",
    frame1598Props: frame15983Data,
    frame15982Props: frame15984Data,
};

const frame15875Data = {
    text55: "Read More",
    arrowsArrowRight: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/releases/60eeef698718caded3164f97/img/arrows-arrow-right@2x.svg",
};

const frame15985Data = {
    blogThumbnail: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/releases/60eeef698718caded3164f97/img/blog-thumbnail-10@2x.svg",
    address: "5 June 2021",
    text223: "Lorem Ipsum passages of Lorem Ipsum available",
    text224: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer quis sapien ac massa dapibus lacinia. Nunc et cursus quam. Cras pharetra condimentum leo,…",
    frame1587Props: frame15875Data,
};

const frame15876Data = {
    text55: "Read More",
    arrowsArrowRight: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/releases/60eeef698718caded3164f97/img/arrows-arrow-right@2x.svg",
};

const frame15986Data = {
    blogThumbnail: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/releases/60eeef698718caded3164f97/img/blog-thumbnail-11@2x.svg",
    address: "5 June 2021",
    text223: "Lorem Ipsum passages of Lorem Ipsum available",
    text224: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer quis sapien ac massa dapibus lacinia. Nunc et cursus quam. Cras pharetra condimentum leo,…",
    className: "bpm-frame-1598-1",
    frame1587Props: frame15876Data,
};

const frame163723Data = {
    className: "bpm-frame-1639",
    frame1598Props: frame15985Data,
    frame15982Props: frame15986Data,
};

const x08BlogsPageMOBILEData = {
    frame145: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/releases/60eeef698718caded3164f97/img/frame-145-4@2x.svg",
    blogs: "Blogs",
    overlapGroup1: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/releases/60eeef698718caded3164f97/img/rectangle-76-7@2x.png",
    text237: "There are many variations of passages of Lorem Ipsum available but the majority have suffered dummy alteration in that an some form by the injected humour or randomised words which don’t look even that slightly believable. If you are Lorem Ipsums your need to be sure there isn’t anything embarrassing. There are many variations passages of Lorem as Ipsums available but the majority have suffered that alterations in that some form by injected humour or randomised words which don’t looks even slightly that believable. If you are Lorem as Ipsum  you need to be sure there isn’t anything as embarrassing. There are many variation of passages Lorem Ipsum available but the majority have suffered that a aalteration in that some form by injected humour or randomised words which don’t look even slightly the believable.",
    frame1626Props: frame1626Data,
    button22Props: button22Data,
    group212Props: group212Data,
    frame16372Props: frame16372Data,
    frame163722Props: frame163722Data,
    frame163723Props: frame163723Data,
};

